<template>
  <div class="searchable-package-list">
  <div class="header-search-package-list">
    <el-input
      prefix-icon="el-icon-search"
      class="query-input"
      :value="query"
      @input="handleQuery"
      placeholder="ค้นหาแพ็กเกจ"
    ></el-input>
    <sc-button
      class="add-all-button"
      :disabled="disabled"
      @click="handleClickSelectedAllButton"
    >เลือกทั้งหมด</sc-button>
  </div>
    <div class="list-body">
      <div class="empty" v-if="noResult">{{ emptyText }}</div>
      <package-selector-option
        class="selected-item"
        v-for="item in selectableOptions"
        :key="item.id"
        v-bind="item"
        :canSelect="canSelect"
        @select="handleSelect(item)"
      ></package-selector-option>
      <infinite-loading @infinite="handleInfinite" ref="infinite"></infinite-loading>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import PackageSelectorOption from "./PackageSelectorOption";
import SelectedPackageList from "./SelectedPackageList";
import ScButton from "@/lib/components/ScButton";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    PackageSelectorOption,
    "el-input": Input,
    SelectedPackageList,
    ScButton,
    InfiniteLoading
  },
  props: ["initialPackages", "value", "disabled", "query"],
  data() {
    return {};
  },
  computed: {
    selectableOptions() {
      return this.value;
    },
    canSelect() {
      return !this.disabled;
    },
    noResult() {
      return this.selectableOptions.length === 0;
    },
    isEmpty() {
      return this.value.length === 0;
    },
    emptyText() {
      if (this.isEmpty) {
        return "ไม่มีแพ็กเกจ";
      }

      return "ไม่พบแพ็กเกจที่ค้นหา";
    }
  },
  methods: {
    handleSelect(item) {
      this.$emit("select", item);

      if (this.selectableOptions.length < 3) {
        return;
      }

      this.$refs.infinite.attemptLoad();
    },
    handleInfinite($state) {
      this.$emit("end", $state);
    },
    handleQuery(query) {
      this.$emit("query-change", query);
    },
    handleClickSelectedAllButton() {
      this.$emit("addAllPackages");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.searchable-package-list {
  border: $border;
  border-radius: $border-radius;

  .el-input__inner {
    border: 0;
    border-bottom: $border;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    height: 43px;
    line-height: 43px;
  }

  > .list-body {
    overflow-y: auto;
    height: 500px;
  }

  > .list-body > .empty {
    padding: 20px 0;
    text-align: center;
  }
}

.header-search-package-list {
  display: grid;
  grid-template-columns: 1fr auto;
  border-bottom: $border;

  > .add-all-button {
    height: 42px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/collections/components/SearchablePackageList.vue